import { CONFIG } from '../config';

export interface ApiRequestInit extends RequestInit {
  token: string;
}

export async function apiFetch(path: string, init: ApiRequestInit): Promise<Response> {
  const { token, headers, ...rest } = init;
  return fetch(`${CONFIG.API_BASE}${path}`, {
    ...rest,
    credentials: 'include',
    headers: {
      ...(headers as Record<string, string>),
      Authorization: `Bearer ${token}`,
    },
  });
}
